import React from "react";

/*
 * The CareIQ tab of a chart with no visit today (owner 10-09): a calm empty
 * state in place of the recommendations and Follow up, the Patient Timeline
 * beside / below it unchanged. statusLine: today's card that did not happen
 * ("Today's 10:30 AM visit is marked no show."). offer: the chart card's own
 * past / future visit as one click ({ label, onOpen }), never opened by itself.
 */
export default function NoVisitToday({ statusLine = "", offer = null }) {
  return (
    <section className="n3-novisit" data-testid="n3-no-visit" aria-label="No visit today">
      <div className="n3-novisit-t">No visit today for this patient.</div>
      {statusLine ? <div className="n3-novisit-s" data-testid="n3-no-visit-status">{statusLine}</div> : null}
      <div className="n3-novisit-s">Pick a visit on the timeline to see its note and CareIQ.</div>
      {offer ? (
        <button type="button" className="n3-lnk no-hover-tint n3-novisit-open" data-act="open-card-visit" onClick={offer.onOpen}>
          {offer.label}
        </button>
      ) : null}
    </section>
  );
}
